import { IconButton } from '@mui/material';
import { useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { useTheme } from 'styled-components';

import { IoMdClose } from 'react-icons/io';
import { Container } from './styles';

type Props = {
  onSearch: (text: string) => void;
  placeholder?: string;
  defaultShowInput?: boolean;
  elementId?: string;
};

export function InputFilter({ onSearch, placeholder, defaultShowInput, elementId }: Props) {
  const theme = useTheme();
  const [displayInput, setDisplayInput] = useState(!!defaultShowInput);

  return (
    <Container hasBorder={displayInput} id={elementId}>
      {displayInput && (
        <input
          type="text"
          placeholder={placeholder || 'O que você quer buscar?'}
          onChange={(e) => onSearch(e.target.value)}
        />
      )}
      <IconButton onClick={() => setDisplayInput((state) => !state)}>
        {displayInput ? (
          <IoMdClose size={25} color={theme.colors.primary} />
        ) : (
          <FiSearch size={25} color={theme.colors.primary} />
        )}
      </IconButton>
    </Container>
  );
}
